<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Monthly Donation">
            <div>
              <AmountSelectorIgnite :includeOther="false" />
              <ErrorLabel field="amount" />
            </div>
          </FormSection>
          <FormSection title="Personal Details">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>                   
          </FormSection>
          <FormSection title="Spouses Details">
            <FormRow inline>
              <div style="width: 100%">
                <FormLabel class="control-label"> First </FormLabel>
                <FormInput
                  type="text"
                  class="width-full"
                  field="custom.spouseFirstName"
                />
              </div>
              <div style="width: 100%">
                <FormLabel class="control-label"> Last </FormLabel>
                <FormInput type="text" class="width-full" field="custom.spouseLastName" />
              </div>
            </FormRow>
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  props: {
    subCampaign: String,
  },
  setup(props) {
    const { getValue, setValue, submit, form } = usePaymentForm();

    return {
      form,
      submit,
    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
::v-deep .form-container.ou-donation-form {
  margin: 20px auto 20px !important;
  padding: 16px !important;

  @media (min-width: 720px) {
    margin: 20px auto !important;
    padding: 20px !important;
    border-radius: 10px !important;
  }
}
</style>
